import { NoteType } from 'entities/Note';
import { TableFilterType } from 'features/TableFilter';
import { getServerDateWithMinuteTimeFormat } from 'shared/utils/helpers/getDateFormat';

interface NoteListFilters {
  warehouseId?: string;
  deadlineDateFrom?: string;
  deadlineDateTo?: string;
  creationDateFrom?: string;
  creationDateTo?: string;
  noteType?: NoteType;
  assignedUsers?: string | string[];
}

export const transformNotesListFilters = ({
  selectedWarehouseId,
  noteType,
  deadlineDateFrom,
  deadlineDateTo,
  creationDateFrom,
  creationDateTo,
  assignedUsers,
}: TableFilterType): NoteListFilters => {
  return {
    warehouseId: selectedWarehouseId?.value || undefined,
    deadlineDateFrom: getServerDateWithMinuteTimeFormat(deadlineDateFrom?.value),
    deadlineDateTo: getServerDateWithMinuteTimeFormat(deadlineDateTo?.value),
    creationDateFrom: getServerDateWithMinuteTimeFormat(creationDateFrom?.value),
    creationDateTo: getServerDateWithMinuteTimeFormat(creationDateTo?.value),
    noteType: noteType?.value || undefined,
    assignedUsers: assignedUsers?.value || undefined,
  };
};
